import { Component, OnInit } from '@angular/core';
import { EmpGrievanceHttpService } from '../emp-grievance-http.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-grievance-link',
  templateUrl: './grievance-link.component.html',
  styleUrls: ['./grievance-link.component.scss']
})
export class GrievanceLinkComponent  implements OnInit {
  isCollapsed: boolean = false;
  isContainerCollapsed: boolean = true;

  containerWidth = '';

  activeView = 'grievance';
  roleDetails: any;

  Grievanceuser1 = false;
  Grievanceuser2 = false;
  constructor(private Service: EmpGrievanceHttpService, private spinner: NgxSpinnerService,) { }

  ngOnInit(): void {

    this.Service.collapsed$.subscribe((state:any) => {
      this.isCollapsed = state;
    });

    this.Service.width$.subscribe((width:any) => {
      this.containerWidth = width;
    });

    this.Service.view$.subscribe((view:any) => {
      this.activeView = view;
    });

  }


}
